import React, { useState, useEffect } from 'react';
import { analyticsAPI } from '../services/api';

function Analytics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await analyticsAPI.getNewUserAnalytics();
      setData(response.data);
    } catch (error) {
      console.error('Error fetching analytics:', error);
      setError('데이터를 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">데이터 로딩 중...</div>;
  }

  if (error) {
    return (
      <div>
        <div className="page-header">
          <h1>신규 가입자 현황</h1>
        </div>
        <div className="error">{error}</div>
      </div>
    );
  }

  if (!data) {
    return <div className="error">데이터가 없습니다.</div>;
  }

  return (
    <div>
      <div className="page-header">
        <h1>신규 가입자 현황</h1>
        <p>당월 신규 가입자 및 최근 30일 추이</p>
      </div>

      {/* KPI Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <h3>당월 총 신규 가입자 수</h3>
          <div className="value">{data.kpis.current_month_total.toLocaleString()}</div>
          <p style={{ fontSize: '12px', color: '#7f8c8d', marginTop: '8px' }}>
            KPI-1
          </p>
        </div>
        
        <div className="stat-card">
          <h3>일평균 신규 가입자 수</h3>
          <div className="value">{data.kpis.daily_average.toLocaleString()}</div>
          <p style={{ fontSize: '12px', color: '#7f8c8d', marginTop: '8px' }}>
            KPI-3
          </p>
        </div>
        
        <div className="stat-card">
          <h3>누적 가입자 수</h3>
          <div className="value">{data.kpis.total_users.toLocaleString()}</div>
          <p style={{ fontSize: '12px', color: '#7f8c8d', marginTop: '8px' }}>
            KPI-4
          </p>
        </div>
      </div>

      {/* Daily Trend Table */}
      <div className="card">
        <div className="card-header">
          <h2>최근 30일 일별 추이</h2>
          <button 
            className="btn btn-secondary"
            onClick={fetchAnalytics}
            style={{ padding: '8px 16px', fontSize: '14px' }}
          >
            ↻ 새로고침
          </button>
        </div>
        
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>날짜</th>
                <th>신규 가입자 수</th>
              </tr>
            </thead>
            <tbody>
              {data.daily_trend && data.daily_trend.length > 0 ? (
                data.daily_trend.map((item, index) => (
                  <tr key={index}>
                    <td>{item.date}</td>
                    <td>
                      <strong>{item.count.toLocaleString()}</strong>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" style={{ textAlign: 'center', color: '#7f8c8d' }}>
                    최근 30일 데이터가 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Summary Stats */}
        {data.daily_trend && data.daily_trend.length > 0 && (
          <div style={{ 
            marginTop: '20px', 
            padding: '15px', 
            background: '#f8f9fa', 
            borderRadius: '4px',
            display: 'flex',
            gap: '30px',
            fontSize: '14px'
          }}>
            <div>
              <strong>총 데이터 포인트:</strong> {data.daily_trend.length}일
            </div>
            <div>
              <strong>기간 총 가입자:</strong>{' '}
              {data.daily_trend.reduce((sum, item) => sum + item.count, 0).toLocaleString()}명
            </div>
            <div>
              <strong>기간 평균:</strong>{' '}
              {(data.daily_trend.reduce((sum, item) => sum + item.count, 0) / data.daily_trend.length).toFixed(1)}명/일
            </div>
          </div>
        )}
      </div>

      {/* Info Note */}
      <div className="card" style={{ background: '#f8f9fa', border: '1px solid #dee2e6' }}>
        <h3 style={{ fontSize: '14px', marginBottom: '10px', color: '#2c3e50' }}>
          📌 안내사항
        </h3>
        <ul style={{ fontSize: '13px', color: '#7f8c8d', lineHeight: '1.8', paddingLeft: '20px' }}>
          <li>당월 데이터는 매월 1일부터 현재까지의 누적 수치입니다.</li>
          <li>일평균은 당월 총 가입자 수를 경과 일수로 나눈 값입니다.</li>
          <li>일별 추이는 최근 30일간의 데이터를 보여줍니다.</li>
          <li>삭제된 사용자는 통계에서 제외됩니다.</li>
        </ul>
      </div>
    </div>
  );
}

export default Analytics;
